// https://github.com/ngrx/platform/issues/931#issuecomment-379318528

import { APP_BOOTSTRAP_LISTENER, Inject, InjectionToken, Type } from '@angular/core';

/**
 * Token to provide bootstrap listeners
 */
export const BOOTSTRAP_LISTENERS = new InjectionToken<Type<any>[]>('Bootstrap Listeners');

/**
 * Creates instances of the provided classes
 */
export function createInstances(...instances: any[]) {
  return instances;
}

/**
 * Provides bootstrap listeners for the application
 * @param listeners Array of classes to be instantiated during bootstrap
 */
export function provideBootstrapListeners(listeners: Type<any>[]) {
  return [
    listeners,
    {
      provide: BOOTSTRAP_LISTENERS,
      deps: listeners,
      useFactory: createInstances
    },
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: (instances: any[]) => () => {
        instances.forEach(instance => {
          if (typeof instance.ngOnInit === 'function') {
            instance.ngOnInit();
          }
        });
      },
      deps: [[new Inject(BOOTSTRAP_LISTENERS)]]
    }
  ];
}
